import React from 'react';
import { Empty } from 'antd';
import OperatorForkliftMobileCard from './OperatorForkliftMobileCard';

export default function OperatorForkliftMobileCardList({
  busy,
  forklifts,
  onSafetyReport,
  onSelect,
  onStartChecklist,
  selectedRowId,
}) {
  return (
    <div className="operator-forklift-card-list" aria-label="Forklift list">
      {forklifts.length ? (
        forklifts.map((forklift) => (
          <OperatorForkliftMobileCard
            key={forklift.id}
            busy={busy}
            forklift={forklift}
            onSafetyReport={onSafetyReport}
            onSelect={onSelect}
            onStartChecklist={onStartChecklist}
            selected={forklift.id === selectedRowId}
          />
        ))
      ) : (
        <div className="operator-forklift-mobile-empty">
          <Empty description="No forklifts found." image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </div>
      )}
    </div>
  );
}
